module.exports = __webpack_public_path__ + "img/botw.b13ae44c.jpg";